module.exports = __webpack_public_path__ + "img/AltoShield.f6ebf7ff.png";